import React, { useState, FC } from 'react';
import { Button, Col, Layout, Row, Space, Switch } from 'antd';

import { useWeb3React } from '@web3-react/core';
import { RoundComponent, SummaryRoundComponent } from 'components/Round';
import listRound from './listRound';
import titleSmall from 'resources/images/title-small-home.png';
import layoutText from 'resources/images/layout-text.png';
import titleBig from 'resources/images/title-big-home.png';
import btnText from 'resources/images/text-btn-connect.png';
import boder from 'resources/images/border-btn-connect.png';
import vestingDetail from 'resources/images/vestin-detail.png';
import investOnly from 'resources/images/invested-only.png';
import bgBig from 'resources/images/background-home-big.png';
import { socialLinks } from 'pages/layout/socials';
const HomePage: FC<any> = ({ connectButtonRef }) => {
  const { account } = useWeb3React();

  const [listRoundVisible, setListRoundVisible] = useState(listRound.map(({ key }) => key)) as any;

  const [summaryData, setSummaryData] = useState({}) as any;

  const toggleConnectWalletModal = () => {
    connectButtonRef.current.triggerClickConnect();
  };

  const updateAllData = (data: any) => {
    const { index, allocationAmount, claimedAmount, availableAmount, claimableAmount } = data;
    setSummaryData((prevState: any) => ({
      ...prevState,
      [index]: {
        allocationAmount: allocationAmount || 0,
        claimedAmount: claimedAmount || 0,
        availableAmount: availableAmount || 0,
        claimableAmount: claimableAmount || 0,
      },
    }));
  };

  return (
<>
    
    {!account && (
      <Layout className="home bg-small">
      <div className="banner banner-guest">
        <div className="container">
          <h4 className="title">
         
            <img src={titleSmall} alt="" />
            <img src={layoutText} alt="" />
          </h4>
          <h5 className="description">
            <img src={titleBig} alt="" />
          </h5>
    
            <button type='submit' className='btnConnect' onClick={toggleConnectWalletModal}>
              <div className='background-btn'></div>
            <img className='img-boder' src={boder} alt="" />
           <img className='img-text' src={btnText} alt="" />
            </button>
        </div>
      </div>
      </Layout>
    )}
    {account && (
       <Layout className="home bg-big">
      <>
        <div className="banner">
          <div className="container">
            <Row className='banner-row'>
              {/* <Col xl={8} xxl={10}></Col> */}
              {/* <Col xs={24} md={24} xl={16} xxl={24} className='banner-row--col'> */}
              <Col span={24} className='banner-row--col'>
                <SummaryRoundComponent account={account} data={summaryData}  />
              </Col>
            </Row>
          </div>
        </div>
        <div className="section section-details">
          <div className="background-white">
            <div className="container">
              {!!listRoundVisible.length && <h4 className="title">
                  <img src={vestingDetail} alt="" />
              </h4>}
             {/* <Space size={12} className="switch">
                <Switch checked={isInvested} onChange={handleChange} disabled={!account} />
               <img src={investOnly} alt="" />
              </Space> */}
              <Row gutter={[20, 18]} className="list-round">
                {listRound.map((item: any, index: number) => (
                  <Col xs={24} md={24} key={index} className='col-round' hidden={!listRoundVisible.includes(item.key)}>
                    <RoundComponent
                      title={item.title}
                      isCountdown={item.isCountdown}
                      updateAllData={updateAllData}
                      index={index}
                      roundType={item.type}
                      nameRound={item.nameRound}
                      setListRoundVisible={setListRoundVisible}
                      keyItem={item.key}
                      {...item}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
      </>
      </Layout>
    )}
</>
  );
};
export default HomePage;
